import {
  HYDROFORECAST_APP_DEV_URL,
  HYDROFORECAST_APP_PROD_URL,
  LOGIN_APP_DEV_URL,
  LOGIN_APP_PROD_URL,
} from './constants';
import {isProd, useLocalLoginApp} from './env';

export const HYDROFORECAST_ROOT_URL = isProd
  ? HYDROFORECAST_APP_PROD_URL
  : HYDROFORECAST_APP_DEV_URL;

export const LOGIN_APP_URL = useLocalLoginApp ? LOGIN_APP_DEV_URL : LOGIN_APP_PROD_URL;

export const UUID_REGEXP =
  /^([0-9a-f]{8})-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function makeUuidPrefix(uuid: string) {
  const match = uuid.match(UUID_REGEXP);

  if (match) {
    return match[1];
  } else {
    return uuid;
  }
}

// Make it's own function so we can mock it out and spy on it in tests
export function setWindowLocationHref(href: string) {
  window.location.href = href;
}

// Signing out clears this origin's Firebase session first, which re-renders the app as logged
// out — and every redirect that sends a logged-out user to the login app's root would then
// race the handoff to its /signOut. Whichever navigation lands last wins, and at the root the
// app switcher hands a still-signed-in user straight back here off the referrer, root session
// untouched. So once a sign-out starts it owns the navigation: root redirects go through
// redirectToLoginApp and stand down, while the /signOut handoff itself navigates directly.
let signOutHandoffStarted = false;

export function startSignOutHandoff() {
  signOutHandoffStarted = true;
}

export function redirectToLoginApp(href: string) {
  if (signOutHandoffStarted) {
    return;
  }
  setWindowLocationHref(href);
}
